// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.CalculatedFieldBody.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * CalculatedFieldBody component
 */
import React from 'react';
import ReactDOM from 'react-dom';
import m, { action } from 'mobx';
import { observer } from 'mobx-react';
import constants from 'logic/data/Izenda.CalculatedFieldConstants';
import Name from './Izenda.CalculatedLabel';
import CalculatedFunction from './Izenda.CalculatedFunction';
import Expression from './Izenda.CalculatedExpression';
import DataType from './Izenda.CalculatedDataType';
import Format from './Izenda.CalculatedFormat';
import Preview from './Izenda.CalculatedPreview';
import Color from './Izenda.CalculateColor';
import Font from './Izenda.CalculateFont';
import Position from './Izenda.CalculatePosition';
import PopoverContainer from './Izenda.PopoverContainer';

@observer
class CalculatedFieldBody extends React.Component {
  static displayName = 'CalculatedFieldBody';

  constructor(props: Object) {
    super(props);

    this.expressionSelectionUI = m.observable({
      visible: false,
      left: 0,
      top: 0,
      cursorPosition: 0
    });
  }

  /**
   * Close expression selection popover.
   */
  closeExpressionSelection = () => {
    this.expressionSelectionUI.visible = false;
  };

  /**
   * Show expression selection popover.
   * @param {Number} position
   */
  @action
  displayExpressionSelection = (position: Number) => {
    // This method is used to show expression selection if it is hiding.
    // Otherwise, hide it.

    const textAreaDom = ReactDOM.findDOMNode(this.refs.textareaInput);
    const left = textAreaDom.offsetLeft + (position && position.left);
    const top = textAreaDom.offsetTop + (position && position.top + 90); // 90: height of bulb icon + 1 line

    // get current cursor position
    const cursorPosition = $izenda('#expressionInput').prop('selectionStart');

    const visible = !this.expressionSelectionUI.visible;

    this.expressionSelectionUI.visible = visible;
    this.expressionSelectionUI.left = left;
    this.expressionSelectionUI.top = top;
    this.expressionSelectionUI.cursorPosition = cursorPosition;
  };

  render() {
    let props = this.props;
    return (
      <div
        className="calculated-field-popup"
        onFocus={this.closeExpressionSelection}>
        <div className="calculated-field-container form-horizontal">
          <Name
            store={props.store}
            type={props.type}
            localization={props.localization}
            requireLabel={props.requireLabel}
          />

          <CalculatedFunction
            store={props.store}
            validation={props.validation}
            type={props.type}
          />

          <Expression
            store={props.store}
            validation={props.validation}
            type={props.type}
            localization={props.localization}
            validateExpression={props.validateExpression}
            ref="textareaInput"
            displayExpressionSelection={this.displayExpressionSelection}
            closeExpressionSelection={this.closeExpressionSelection}
            expressionSelectionUI={this.expressionSelectionUI}
          />

          <DataType
            store={props.store}
            validation={props.validation}
            localization={props.localization}
            type={props.type}
            reportDesigner={props.reportDesigner}
            reportPart={props.reportPart}
          />

          <Format
            store={props.store}
            localization={props.localization}
            type={props.type}
          />

          <Font
              store={props.store}
              localization={props.localization}
              type={props.type}
          />

          <Color
            store={props.store}
            localization={props.localization}
            type={props.type}
          />

          {/* <Position
            store={props.store}
            localization={props.localization}
            type={props.type}
          /> */}

          <Preview
            store={props.store}
            localization={props.localization}
            validation={props.validation}
            type={props.type}
            updateError={props.updateError}
            reportDesigner={props.reportDesigner}
            reportPart={props.reportPart}
            startLoading={props.startLoading}
            endLoading={props.endLoading}
            querySourceId={props.querySourceId}
          />
        </div>
        <PopoverContainer
          expressionConfig={props.expressionConfig}
          store={props.store}
          type={props.type}
          expressionSelectionUI={this.expressionSelectionUI}
          displayExpressionSelection={this.displayExpressionSelection}
          sourceId="expressionInput"
        />
      </div>
    );
  }
}

export default CalculatedFieldBody;



// WEBPACK FOOTER //
// ./ui/share/components/controls/calculatedField/Izenda.CalculatedFieldBody.js